<h1 class="u-sr-only">{{ 'Sidebar.Menu.Promo' | translate }}</h1>
<div class="o-grid">
	<div class="o-grid__cell">
		<div class="c-card c-card--s3">
			<div class="c-content u-no-p@up-to-md u-no-ph">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--o3@md-and-up o-grid__cell--center-v u-no-p">
						<section class="c-section c-section--first u-no-mh u-no-p" [ngClass]="{'c-section--error': vm.formSubmitted && (vm.invalid || vm.error)}" panel>
							<div class="c-section__header">
								<h2 class="c-section__title u-hidden@md-and-up">{{ 'Promo.Received' | translate }}</h2>
							</div>
							<div class="c-section__content">
								<div class="c-content c-content--xxl">
									<div class="c-content c-content--xxl u-no-pv u-no-p@up-to-lg">
										<p class="c-text c-text--s12 c-text--bold c-text--center u-ost-sm u-osb-sm">{{ 'Promo.Title2' | translate }}</p>
										<div class="c-content c-content--xxl c-content--wrapper u-osb-sm@up-to-md u-no-ph">
											<p id="promoCodeSuccessLabel" class="c-text c-text--bold c-text--center c-text--main" *ngIf="vm.success">{{ vm.success }}</p>
											<form #promoForm="ngForm" class="c-form" (ngSubmit)="vm.handleFormSubmit(promoForm)" novalidate="novalidate" autocomplete="off">
												<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': vm.formSubmitted && (promoForm.form.controls.code?.invalid || vm.error)}">
													<label for="code" class="c-form__label u-osb-xs">{{ 'Promo.Code' | translate }}</label>
													<div class="o-grid">
														<div class="o-grid__cell o-grid__cell--w-fit u-no-p">
															<input type="text" id="code" name="code" class="c-form__input" [(ngModel)]="vm.code" required (change)="vm.handleInputChange()" #codeModel="ngModel"/>
														</div>
														<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
															<button id="promoCodeSubmitButton" type="submit" class="c-button c-button--s2 c-button--narrow c-form__button u-no-wrap">{{ 'Promo.Add' | translate }}</button>
														</div>
													</div>
													<item-form-error [fieldName]="'Promo.Code' | translate" [error]="codeModel.errors" *ngIf="vm.formSubmitted && codeModel.invalid"></item-form-error>
													<p id="promoCodeErrorLabel" class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.formSubmitted && vm.error">{{ 'Promo.Errors.' + vm.error | translate }}</p>
												</div>
											</form>
											<loader-overlay *ngIf="vm.processing"></loader-overlay>
										</div>
										<p class="c-text c-text--center">{{ 'Promo.Text3' | translate }}</p>
									</div>
								</div>
							</div>
						</section>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-hidden@up-to-md o-grid__cell--o2 u-no-p" style="margin-right:-1px">
						<div class="c-divider c-divider--v"></div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--o1@md-and-up o-grid__cell--center-v u-no-p">
						<section class="c-section c-section--last c-section--static c-section--open u-no-mh u-no-p">
							<div class="c-section__content">
								<div class="c-content c-content--xxl">
									<div class="c-content c-content--xxl u-no-pv u-no-p@up-to-lg">
										<div class="o-grid o-grid--center-h u-osb-sm">
											<div class="o-grid__cell o-grid__cell--w-50">
												<img alt="Share promo code picture" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/payment.svg">
											</div>
										</div>
										<h2 class="c-text c-text--s12 c-text--bold c-text--center u-no-m@md-and-up u-osb-sm@up-to-md">{{ 'Promo.Title1' | translate }}</h2>
										<div class="c-content c-content--xxl u-osb-sm@up-to-md u-no-ph">
											<p class="c-text c-text--s12 c-text--bold c-text--center u-no-m">
												<span class="c-text--s13">{{ vm.userPromoCode }}</span>
											</p>
										</div>
										<p class="c-text c-text--center">{{ 'Promo.Text1' | translate }}</p>
										<p class="c-text c-text--center c-text--sm">* {{ 'Promo.Text2' | translate }}</p>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
